var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.3096 7.64185L8 13.3678L1.69038 7.64185L2.67325 6.58034L7.27273 10.7544L7.27273 0.871094L8.72727 0.871094L8.72727 10.7544L13.3267 6.58034L14.3096 7.64185Z","fill":"black","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 15.2711H1.45455V17.4311H14.5455V15.2711H16V18.8711H0V15.2711Z","fill":"black","key":1})]);
}

Download.defaultProps = {"width":"16","height":"19","viewBox":"0 0 16 19","fill":"none"};

module.exports = Download;

Download.default = Download;
